"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @reducer rootReducer - this combines all the top level reducers into a single root
 */
var redux_1 = require("redux");
var index_1 = require("./reducers/index");
// Each of reducer will produce their own section names in the Store
var allReducers = Object.assign({}, 
// Server reducers - they are all in /reducers/generic
index_1.default.generic, {
    // Client reducers
    'modal': index_1.default.modal,
    'route': index_1.default.route,
    'ui': index_1.default.ui,
    'account': index_1.default.account,
    // Extra props provided by ReactEngine
    '__meta': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'context': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'locale': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'userConfig': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'locality': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'sys': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    },
    'cache': function (state) {
        if (state === void 0) { state = {}; }
        return state;
    }
});
var rootReducer = redux_1.combineReducers(allReducers);
exports.default = rootReducer;
